import Login from '@/pages/Login'

export default {
  path: '/login',
  component: Login,
  children: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/login/activate/:activatetoken',
      name: 'ActivateToken',
      component: Login,
    },
    {
      path: '/login/resetpassword/:resettoken',
      name: 'ResetPassword',
      component: Login,
    },
  ]
  // path: '/login',
  // name: 'login',
  // component: Login
}



// WEBPACK FOOTER //
// ./src/router/login.js